import type { Stores, Operations } from "./stores";
import { migrateObjectStores, createObjectStoreOperations } from "./stores";

/**
 * @description
 * IndexedDB initialization.
 * Perform migration if needed , comparing existing
 * ObjectStore via their name and create them if absent.
 */
export const initializeIndexedDB = <D extends Stores>(
  name: string,
  version: number,
  definitions: D,
) =>
  new Promise<Operations<D>>((resolve, reject) => {
    console.debug("Initializing IndexedDB v" + version);
    const req = globalThis.indexedDB.open(name, version);
    req.onupgradeneeded = () => {
      console.debug("Upgrading IndexedDB");
      migrateObjectStores(req.result, definitions);
    };
    req.onsuccess = () => resolve(createObjectStoreOperations(req.result, definitions));
    req.onerror = err => reject(err);
  });
